<template>
  <q-page padding>
    <div
      class="row col-12 text-brand-5"
      style="cursor: pointer"
      @click="voltar()"
    >
      <q-icon
        style="margin-top: 3px"
        size="sm"
        name="arrow_back_ios"
        class="cursor"
      />
      <p class="text-h6 text-brand-1 text-weight-bold texto-titulo">
        Detalhe da Transferência ID: {{ transferenciaId }}
      </p>
    </div>
    <div
      class="row col-12 q-col-gutter-sm text-brand-5 text-weight-bold q-mt-md q-ml-sm container-inputs"
    >
      <div class="col-md-3 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Estoque Origem</div>
        <q-input
          v-model="transferenciaDetalhes.estoqueOrigem"
          disable
          bg-color="brand-7"
          dense
          outlined
          class="input-new-design"
        />
      </div>
      <div class="col-md-3 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Estoque Destino</div>
        <q-input
          v-model="transferenciaDetalhes.estoqueDestino"
          disable
          bg-color="brand-7"
          dense
          outlined
          class="input-new-design"
        />
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Criado Em</div>
        <q-input
          v-model="transferenciaDetalhes.criadaEm"
          disable
          bg-color="brand-7"
          dense
          outlined
          class="input-new-design"
        />
      </div>
      <div class="col-md-3 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Status</div>
        <q-input
          v-model="transferenciaDetalhes.status"
          disable
          bg-color="brand-7"
          dense
          outlined
          class="input-new-design"
        />
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Solicitante</div>
        <q-select
          v-model="dados.usuario"
          :options="listaUsuarios"
          outlined
          dense
          @filter="filterSolicitante"
          use-input
          hide-selected
          fill-input
          option-label="name"
          input-debounce="300"
          class="input-new-design"
          :disable="
            transferenciaDetalhes.status == 'recebido' ||
            transferenciaDetalhes.status == 'enviado' ||
            transferenciaDetalhes.status == 'recebido_diferente' ||
            disable
          "
        />
      </div>
      <div class="col-md-3 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Separador</div>
        <q-select
          v-model="dados.separador"
          :options="listaUsuariosSeparador"
          outlined
          dense
          @filter="filterSeparator"
          use-input
          hide-selected
          fill-input
          option-label="name"
          input-debounce="300"
          class="input-new-design"
          :disable="
            transferenciaDetalhes.status == 'recebido' ||
            transferenciaDetalhes.status == 'enviado' ||
            transferenciaDetalhes.status == 'recebido_diferente' ||
            disable
          "
        />
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Solicitação Compra</div>
        <q-input
          :disable="
            transferenciaDetalhes.status == 'recebido' ||
            transferenciaDetalhes.status == 'enviado' ||
            disable
          "
          type="number"
          dense
          outlined
          class="input-new-design"
          v-model="necessidade"
        />
      </div>
      <div class="q-ml-sm">
        <p></p>
        <q-btn
          class="q-mt-sm"
          dense
          size="md"
          flat
          icon="done"
          round
          color="positive"
          @click="alterarNecessidade()"
        />
      </div>
      <div class="q-ml-sm">
        <p></p>
        <q-btn
          class="q-mt-sm"
          dense
          size="md"
          flat
          icon="sym_o_history"
          color="black"
          round
          :disable="historico.criacao == null"
          @click="rightDrawerOpen = true"
        />
      </div>

      <div class="q-ml-xs">
        <p></p>
        <router-link
          :to="{
            name: 'transferencia-imprimir',
            params: { transferenciaId: transferenciaId },
          }"
        >
          <q-btn
            class="q-mt-sm"
            dense
            size="md"
            flat
            icon="sym_o_print"
            color="brand-1"
            round
            @click="rightDrawerOpen = true"
          />
        </router-link>
      </div>
    </div>

    <div
      v-if="
        transferenciaDetalhes.status != 'recebido' &&
        transferenciaDetalhes.status != 'enviado' &&
        transferenciaDetalhes.status != 'recebido_diferente'
      "
      class="q-mt-xl"
    >
      <q-table
        :columns="columns"
        :loading="loading"
        :rows="listaProdutosEstoque"
        dense
        style="max-height: 500px; overflow: hidden; overflow-y: scroll"
        color="primary"
        class="my-sticky-dynamic"
        table-header-class="bg-accent text-weight-bold"
        flat
        hide-bottom
        :grid="$q.screen.lt.sm"
        :rows-per-page-options="[0]"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Produtos</span
          >
        </template>
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            type="text"
            class="col-md-3 col-xs-10"
            placeholder="Pesquisar"
            v-model="filtros.produtoEstoque"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-7">
                  <div class="row col-12 q-ml-sm q-mt-sm">
                    <span class="q-mr-sm"
                      ><strong class="q-mr-xs">Código: </strong>
                      {{ props.row.codigo }}</span
                    >
                  </div>
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Descrição: </strong>
                    {{ props.row.destino_descricao }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Estoque Origem: </strong>
                    {{ props.row.origem_estoque }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Estoque Destino: </strong>
                    {{ props.row.destino_estoque }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Repo. Destino: </strong>
                    {{ props.row.destino_maximo }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Qtd. Comprometida: </strong>
                    {{ props.row.quantidade_comprometida }}</span
                  >
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Loc. Origem: </strong>
                    <input
                      v-model="props.row.lote"
                      type="text"
                      class="input-codigo-epi-grid"
                      :disabled="props.row.controla_lote == 0"
                    />
                  </span>
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Qtd a ser Transferida: </strong>
                    <input
                      v-model="props.row.quantidade"
                      type="text"
                      class="input-codigo-epi-grid"
                    />
                  </span>
                </div>
                <div class="col-5">
                  <div class="row col-12 justify-end">
                    <q-btn
                      icon="add"
                      color="secondary"
                      round
                      :disable="disable"
                      @click="adicionarProduto(props.row)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-codigo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.codigo }}
          </q-td>
        </template>
        <template v-slot:body-cell-descricao="props">
          <q-td
            class="text-brand-5 text-weight-bold descricao-produto"
            :props="props"
          >
            {{ props.row.destino_descricao }}
          </q-td>
        </template>
        <template v-slot:body-cell-estoqueOrigem="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.origem_estoque }}
          </q-td>
        </template>
        <template v-slot:body-cell-estoqueDestino="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.destino_estoque }}
          </q-td>
        </template>
        <template v-slot:body-cell-maxDestino="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.destino_maximo }}
          </q-td>
        </template>
        <template v-slot:body-cell-quantidadeComprometida="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.quantidade_comprometida }}
          </q-td>
        </template>
        <template v-slot:body-cell-localizacaoOrigem="props">
          <q-td :props="props">
            <q-select
              v-model="props.row.lote"
              style="min-width: 100px"
              dense
              outlined
              :options="options(props.row.id)"
              :disable="props.row.controla_lote == 0"
              :bg-color="props.row.controla_lote == 0 ? 'brand-7' : ''"
            />
          </q-td>
        </template>
        <template v-slot:body-cell-quantidadeTransferido="props">
          <q-td :props="props">
            <q-input
              v-model="props.row.quantidade"
              style="width: 100px"
              dense
              outlined
            />
          </q-td>
        </template>
        <template v-slot:body-cell-adicionar="props">
          <q-td :props="props">
            <q-btn
              icon="add"
              color="secondary"
              round
              :disable="disable"
              @click="adicionarProduto(props.row)"
            />
          </q-td>
        </template>
      </q-table>
    </div>
    <div class="q-mt-xl">
      <q-table
        :columns="columns2"
        :loading="loading"
        :rows="produtosSelecionados"
        dense
        color="primary"
        class="tabela-tamanho-fixo"
        table-header-class="bg-accent text-weight-bold"
        flat
        hide-bottom
        :grid="$q.screen.lt.sm"
        :rows-per-page-options="[0]"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Produtos Selecionados</span
          >
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-7">
                  <div class="row col-12 q-ml-sm q-mt-sm">
                    <span class="q-mr-sm"
                      ><strong class="q-mr-xs">Código: </strong>
                      {{ props.row.codigo_produto }}</span
                    >
                  </div>
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Descrição: </strong>
                    {{ props.row.nome_produto }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Preço: </strong>
                    {{
                      `R$ ${parseFloat(props.row.origem_preco_produto)}`
                    }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Estoque Origem: </strong>
                    {{ props.row.origem_estoque }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Estoque Destino: </strong>
                    {{ props.row.destino_estoque }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs"
                      >Estoque Reposição Destino:
                    </strong>
                    {{ props.row.destino_ponto_reposicao }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Quantidade Enviada: </strong>
                    {{ props.row.quantidade_saida }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Loc. Saida: </strong>
                    {{ props.row.lote }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Valor Transferido: </strong>
                    {{
                      `R$ ${parseFloat(
                        props.row.origem_preco_produto *
                          props.row.quantidade_saida
                      ).toFixed(2)}`
                    }}</span
                  >
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Quantidade Recebida: </strong>
                    <input
                      v-model="props.row.quantidade"
                      type="text"
                      class="input-codigo-epi-grid"
                      :disabled="transferenciaDetalhes.status != 'enviado'"
                    />
                  </span>
                </div>
                <div class="col-5">
                  <div class="row col-12 justify-end">
                    <q-btn
                      icon="delete"
                      color="red"
                      flat
                      round
                      @click="removerProduto(props.row)"
                      :disable="
                        transferenciaDetalhes.status == 'recebido' ||
                        transferenciaDetalhes.status == 'enviado' ||
                        transferenciaDetalhes.status == 'recebido_diferente'
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-codigo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.codigo_produto }}
          </q-td>
        </template>
        <template v-slot:body-cell-descricao="props">
          <q-td
            class="text-brand-5 text-weight-bold descricao-produto"
            :props="props"
          >
            {{ props.row.nome_produto }}
          </q-td>
        </template>
        <template v-slot:body-cell-preco="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ `R$ ${parseFloat(props.row.origem_preco_produto).toFixed(2)}` }}
          </q-td>
        </template>
        <template v-slot:body-cell-estoqueOrigem="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.origem_estoque }}
          </q-td>
        </template>
        <template v-slot:body-cell-estoqueDestino="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.destino_estoque }}
          </q-td>
        </template>
        <template v-slot:body-cell-estoqueReposicaoDestino="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.destino_ponto_reposicao }}
          </q-td>
        </template>
        <template v-slot:body-cell-quantidadeEnviado="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.quantidade_saida }}
          </q-td>
        </template>
        <template v-slot:body-cell-localizacaoSaida="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.lote }}
          </q-td>
        </template>
        <template v-slot:body-cell-valorTransferido="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              `R$ ${parseFloat(
                props.row.origem_preco_produto * props.row.quantidade_saida
              ).toFixed(2)}`
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-quantidadeRecebida="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <q-input
              v-model="props.row.quantidade"
              style="width: 100px"
              dense
              outlined
              :disable="transferenciaDetalhes.status != 'enviado'"
            />
          </q-td>
        </template>
        <template v-slot:body-cell-remover="props">
          <q-td :props="props">
            <q-btn
              icon="delete"
              color="red"
              flat
              round
              @click="removerProduto(props.row)"
              :disable="
                transferenciaDetalhes.status == 'recebido' ||
                transferenciaDetalhes.status == 'enviado' ||
                transferenciaDetalhes.status == 'recebido_diferente'
              "
            />
          </q-td>
        </template>
      </q-table>
    </div>

    <div
      v-if="
        (transferenciaDetalhes.status != 'rascunho' &&
          transferenciaDetalhes.status != 'recebido' &&
          transferenciaDetalhes.status != 'recebido_diferente') ||
        transferenciaDetalhes.status == 'criado' ||
        transferenciaDetalhes.status == 'enviado'
      "
      class="row q-mt-xl col-12 container-autenticacao"
    >
      <div
        style="font-size: 15px"
        class="row col-12 texto-titulo-tabela text-brand-5 text-weight-bold"
      >
        Tipo de Assinatura
      </div>
      <q-radio
        v-if="
          !$store.state.autenticacao.cliente.includes('staging-vale') &&
          !$store.state.autenticacao.cliente.includes('vale-epiexpress') &&
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'transfer-auth-assinatura'
          ) != -1
        "
        v-model="tipoAuth"
        label="Assinatura"
        val="assinatura"
        :size="mobile ? 'sm' : 'lg'"
      />
      <q-radio
        v-model="tipoAuth"
        label="Biometria"
        val="biometria"
        :size="mobile ? 'sm' : 'lg'"
        v-if="
          !mobile &&
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'transfer-auth-biometria'
          ) != -1
        "
      />
      <q-radio
        v-if="
          !$store.state.autenticacao.cliente.includes('staging-acciona') &&
          !$store.state.autenticacao.cliente.includes('acciona') &&
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'transfer-auth-pin'
          ) != -1
        "
        v-model="tipoAuth"
        label="PIN"
        val="web_pin"
        :size="mobile ? 'sm' : 'lg'"
      />
      <q-radio
        v-if="
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'transfer-auth-token'
          ) != -1
        "
        v-model="tipoAuth"
        label="Token"
        val="token"
        :size="mobile ? 'sm' : 'lg'"
      />

      <div
        v-if="
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'transfer-auth-pin'
          ) == -1 &&
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'transfer-auth-biometria'
          ) == -1 &&
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'transfer-auth-assinatura'
          ) == -1 &&
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'transfer-auth-token'
          ) == -1
        "
        class="q-my-md"
      >
        <span
          >Você não possui nenhum método de autenticação associado ao seu
          usuário, entre em contato com o suporte.</span
        >
      </div>
    </div>
    <div
      class="row col-12 q-mt-lg q-ml-md items-center container-autenticacao-pin"
      v-if="
        tipoAuth === 'web_pin' &&
        transferenciaDetalhes.status != 'rascunho' &&
        transferenciaDetalhes.status != 'recebido' &&
        transferenciaDetalhes.status != 'recebido_diferente'
      "
    >
      <q-icon class="q-mr-xs" name="lock" size="28px" />
      <div class="col-md-2 col-xs-6">
        <q-input v-model="pin" type="password" dense outlined />
      </div>
    </div>
    <div
      v-if="
        tipoAuth == 'assinatura' &&
        transferenciaDetalhes.status != 'rascunho' &&
        transferenciaDetalhes.status != 'recebido' &&
        transferenciaDetalhes.status != 'recebido_diferente'
      "
      class="row col-12 q-mt-md canvas-container"
    >
      <Canvas @update="recebeAssinatura" :go="salvarAssinatura" />
    </div>
    <biometria
      tipoBiometria="verificacao"
      :modal="biometria"
      :userId="usuarioBiometria"
      :titulo="
        filtros.status == 'finalizado'
          ? 'Enviar Transferencia'
          : 'Receber transferencia'
      "
      @negativePrint="recebeBiometria"
      @resultadoVerificacao="receberResultadoBiometria"
    >
    </biometria>
    <div
      style="max-width: 250px"
      v-if="
        filtros.status != 'recebido' &&
        transferenciaDetalhes.status != 'rascunho' &&
        transferenciaDetalhes.status != 'recebido' &&
        transferenciaDetalhes.status != 'recebido_diferente'
      "
      class="col-md-2 col-xs-4 q-mt-sm"
    >
      <div class="texto-titulo-input text-weight-bold q-ml-sm">
        Usuario Indicado
      </div>
      <SelecaoSolicitante
        :buscarFuncionario="true"
        :atualizarDados="atualizarDados"
        :model="usuarioLogado"
        @emitirFuncionario="receberUsuarioBiometria"
      />
    </div>
    <div
      v-if="
        transferenciaDetalhes.status != 'recebido' &&
        transferenciaDetalhes.status != 'recebido_diferente'
      "
      class="row col-3 q-mt-xl"
    >
      <div class="col-3">
        <q-btn
          no-caps
          class="full-width"
          :disable="
            transferenciaDetalhes.status != 'rascunho' &&
            usuarioBiometria == null
          "
          icon="add"
          :label="labelAlterarTransferencia"
          color="positive"
          @click="alterarEstadoTransferencia()"
        />
      </div>
    </div>
    <q-dialog v-model="confirm" persistent>
      <q-card class="q-pa-sm text-brand-5 text-weight-bolder">
        <q-card-section class="row items-center">
          <span class="q-ml-sm"
            >Você tem certeza que deseja alterar o
            {{ userTipo ? "separador" : "solicitante" }}?</span
          >
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            icon="cancel"
            no-caps
            dense
            outline
            label="Não"
            color="negative"
            v-close-popup
          />
          <q-btn
            no-caps
            dense
            outline
            label="Sim"
            color="positive"
            v-close-popup
            icon="check_circle_outline"
            @click="userTipo ? alterarSeparador() : alterarSolicitante()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <ModalInformacaoesAdicionais
      :rightDrawerOpen="rightDrawerOpen"
      :nomeModal="'Histórico Transferência'"
      @fecharModal="rightDrawerOpen = false"
    >
      <template v-slot:conteudo-modal>
        <div class="row col-12">
          <div class="row col-12">
            <div v-if="historico.criacao" class="col-12 q-mt-sm">
              <q-separator class="row col-12" color="brand-5" />
              <span class="row col-12 q-mt-xs">Criado Por</span>
              <span class="row col-12 q-mt-sm">
                <span class="col">Nome: {{ historico.criacao?.nome }}</span>
                <span class="col">Matricula: {{ historico.criacao?.sap }}</span>
                <span class="col column"
                  >Data Criação:
                  <span>
                    {{
                      historico.criacao?.created_at?.date
                        ?.split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    }}</span
                  >

                  <span>
                    <span>{{
                      historico.criacao?.created_at?.date
                        ?.split(" ")[1]
                        .replace(/\.?0+$/, "")
                    }}</span></span
                  >
                </span>
              </span>
            </div>

            <div
              v-if="historico.manipulacaoEnvio || historico.envio"
              class="col-12 q-mt-sm"
            >
              <q-separator class="row col-12" color="brand-5" />
              <span class="row col-12 q-mt-xs">Enviado Por</span>
              <span class="row col-12 q-mt-sm">
                <span class="col"
                  >Nome:
                  {{
                    historico.manipulacaoEnvio?.nome ?? historico.envio?.nome
                  }}</span
                >
                <span class="col"
                  >Matricula:
                  {{
                    historico.manipulacaoEnvio?.sap ?? historico.envio?.sap
                  }}</span
                >
                <span class="col column"
                  >Data Envio:
                  <span>
                    {{
                      historico.manipulacaoEnvio?.created_at?.date
                        ?.split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    }}</span
                  >
                  <span>{{
                    historico.manipulacaoEnvio?.created_at?.date
                      ?.split(" ")[1]
                      .replace(/\.?0+$/, "")
                  }}</span>
                </span>
              </span>
            </div>

            <div
              v-if="historico.manipulacaoRecebimento || historico.recebimento"
              class="col-12 q-mt-sm"
            >
              <q-separator class="row col-12" color="brand-5" />
              <span class="row col-12 q-mt-xs">Recebido Por</span>
              <span class="row col-12 q-mt-sm">
                <span class="col"
                  >Nome:
                  {{
                    historico.manipulacaoRecebimento?.nome ??
                    historico.recebimento?.nome
                  }}</span
                >
                <span class="col"
                  >Matricula:
                  {{
                    historico.manipulacaoRecebimento?.sap ??
                    historico.recebimento?.sap
                  }}</span
                >
                <span class="col column"
                  >Data Recebimento:
                  <span>
                    {{
                      historico.manipulacaoRecebimento?.created_at?.date
                        ?.split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    }}
                  </span>

                  <span>{{
                    historico.manipulacaoRecebimento?.created_at?.date
                      ?.split(" ")[1]
                      .replace(/\.?0+$/, "")
                  }}</span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </template>
    </ModalInformacaoesAdicionais>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </q-page>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { useQuasar } from "quasar";

import SelecaoSolicitante from "../../../picking/components/SelecaoSolicitante.vue";
import Biometria from "../../../biometria/views/Biometria.vue";
import Canvas from "../../../requisicao/components/Canvas.vue";
import ModalInformacaoesAdicionais from "../../../requisicao/components/ModalInformacaoesAdicionais.vue";

const columns = [
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "estoqueOrigem",
    label: "Estoque Origem",
    align: "left",
  },
  {
    name: "estoqueDestino",
    label: "Estoque Destino",
    align: "left",
  },

  {
    name: "maxDestino",
    label: "Max. Destino",
    align: "left",
  },
  {
    name: "quantidadeComprometida",
    label: "Qtd. Comprometida",
    align: "left",
  },
  {
    name: "localizacaoOrigem",
    label: "Localização Origem",
    align: "left",
  },

  {
    name: "quantidadeTransferido",
    label: "Qtd. a ser Transferido",
    align: "left",
  },
  {
    name: "adicionar",
    label: "Adicionar",
    align: "left",
  },
];
const columns2 = [
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "preco",
    label: "Preço",
    align: "left",
  },
  {
    name: "estoqueOrigem",
    label: "Estoque Origem",
    align: "left",
  },
  {
    name: "estoqueDestino",
    label: "Estoque Destino",
    align: "left",
  },
  {
    name: "estoqueReposicaoDestino",
    label: "Estoque Reposição Destino",
    align: "left",
  },
  {
    name: "quantidadeEnviado",
    label: "Qtd. Enviada",
    align: "left",
  },
  {
    name: "localizacaoSaida",
    label: "Loc. Saida",
    align: "left",
  },
  {
    name: "valorTransferido",
    label: "Valor Transferido",
    align: "left",
  },
  {
    name: "quantidadeRecebida",
    label: "Quantidade Recebida",
    align: "left",
  },
  {
    name: "remover",
    label: "Remover",
    align: "center",
  },
];
export default {
  components: {
    Biometria,
    SelecaoSolicitante,
    ModalInformacaoesAdicionais,
    Canvas,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const quasar = useQuasar();
    const biometria = ref(false);
    const imagemBase64 = ref(null);
    const salvarAssinatura = ref(0);
    const necessidade = ref("");
    const time = ref();
    const transferenciaId = route.params.transferenciaId;
    const dados = ref({
      usuario: "",
      unidadeId: "",
      separador: "",
      origemId: "",
    });
    const transferenciaDetalhes = ref({
      estoqueOrigem: "",
      estoqueDestino: "",
      criadaEm: "",
      status: "",
      solicitante: "",
      separador: "",
      statusRecebedor: "",
    });
    const listaUsuarios = ref([]);
    const listaUsuariosSeparador = ref([]);

    const getUsuarioId = () => {
      const usuario = store.state.autenticacao.usuarioLogado;

      if (usuario.idTabela && typeof usuario.idTabela === "number") {
        return usuario.idTabela;
      }

      if (usuario.idTabela && !isNaN(parseInt(usuario.idTabela))) {
        return parseInt(usuario.idTabela);
      }

      if (store.state.autenticacao.idBase) {
        return store.state.autenticacao.idBase;
      }

      if (typeof usuario.id === "number") {
        return usuario.id;
      }

      if (!isNaN(parseInt(usuario.id))) {
        return parseInt(usuario.id);
      }
      return null;
    };

    const usuarioBiometria = ref(getUsuarioId());
    const pin = ref("");
    const tipoAuth = ref(null);
    const filtros = ref({
      usuario: "",
      produtoEstoque: "",
      produtoTabelaFiltro: "",
    });
    let loadingInner = ref(false);
    let loadingInnerSeparador = ref(false);
    const listaProdutosEstoque = ref([]);
    const produtosSelecionados = ref([]);
    let userTipo = ref(false);
    let confirm = ref(false);
    let mobile = ref(false);
    let loading = ref(false);
    const labelAlterarTransferencia = ref("");
    const optionsFiltroProdutos = ref([]);
    const usuarioLogado = ref({
      id: store.state.autenticacao.usuarioLogado.id,
      name: store.state.autenticacao.usuarioLogado.nome,
    });
    const atualizarDados = ref(0);
    const alterarIndividuos = ref(false);
    const rightDrawerOpen = ref(false);
    const historico = ref({
      criacao: null,
      envio: null,
      manipulacaoEnvio: null,
      recebimento: null,
      manipulacaoRecebimento: null,
    });
    const disable = ref(false);
    const produtosDetalhe = ref([]);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const detalharTransferencia = async () => {
      disable.value = true;
      alterarIndividuos.value = false;
      atualizarDados.value++;
      try {
        const response = await store.dispatch(
          "transferencia/detalharTransferencia",
          { id: transferenciaId }
        );

        let objeto = response.data.result;
        produtosDetalhe.value = objeto.produtos || [];
        dados.value.unidadeId = objeto.depositoEntrada.id;
        dados.value.origemId = objeto.depositoSaida.id;
        transferenciaDetalhes.value = {
          estoqueOrigem: objeto.depositoSaida.descricao,
          estoqueDestino: objeto.depositoEntrada.descricao,
          criadaEm:
            objeto.createdAt.date
              ?.split(" ")[0]
              ?.split("-")
              ?.reverse()
              .join("/") || formatDateBrasil(objeto?.createdAt),
          status: objeto.status.valor,
          statusRecebedor: objeto.status.valor,
          solicitante: objeto.operador_solicitacao?.nome
            ? {
                name: objeto.operador_solicitacao?.nome,
                id: objeto.operador_solicitacao?.id,
              }
            : "",
          separador: objeto.operador_separacao?.nome
            ? {
                name: objeto.operador_separacao?.nome,
                id: objeto.operador_separacao?.id,
              }
            : "",
        };
        dados.value.usuario = objeto.operador_solicitacao?.nome
          ? {
              name: objeto.operador_solicitacao?.nome,
              id: objeto.operador_solicitacao?.id,
            }
          : "";

        dados.value.separador = objeto.operador_separacao?.nome
          ? {
              name: objeto.operador_separacao?.nome,
              id: objeto.operador_separacao?.id,
            }
          : "";

        historico.value = {
          criacao: objeto.operador_criacao ? objeto.operador_criacao : null,
          envio: objeto.operador_envio ? objeto.operador_envio : null,
          manipulacaoEnvio: objeto.operador_manipulacao_envio
            ? objeto.operador_manipulacao_envio
            : null,
          recebimento: objeto.operador_recebimento
            ? objeto.operador_recebimento
            : null,
          manipulacaoRecebimento: objeto.operador_manipulacao_recebimento
            ? objeto.operador_manipulacao_recebimento
            : null,
        };
        necessidade.value = objeto?.necessidade_compra?.numero;

        if (transferenciaDetalhes.value.status == "recebido") {
          transferenciaDetalhes.value.statusRecebedor = `${
            objeto.status.valor
          } (${objeto.operador_recebimento?.nome?.toUpperCase()})`;
        }
        await listarUsuarios();
        await listarSeparador();
        await listarProdutosEstoque();
        await listagemDetalhada();
        definirLabelBotaoAlterarTransferencia();
        alterarIndividuos.value = true;
        disable.value = false;
      } catch (error) {
        console.log(error);
        disable.value = false;
      }
    };

    const listarUsuarios = async (value) => {
      try {
        loadingInner.value = true;
        const response = await store.dispatch("transferencia/listarUsuarios", {
          per_page: 4,
          search: value,
        });
        listaUsuarios.value = response.data.results.data;
        loadingInner.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const listarSeparador = async (value) => {
      try {
        loadingInnerSeparador.value = true;
        const response = await store.dispatch("transferencia/listarUsuarios", {
          per_page: 4,
          search: value,
        });
        listaUsuariosSeparador.value = response.data.results.data;
        loadingInnerSeparador.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const voltar = () => {
      router.push({ name: "transferencia-listar" });
    };

    const listarProdutosEstoque = async () => {
      try {
        loading.value = true;
        const response = await store.dispatch(
          "transferencia/listarProdutosEstoque",
          {
            vendor_id_destino: dados.value.unidadeId,
            vendor_id_origem: dados.value.origemId,
            produto: filtros.value.produtoEstoque,
            abaixo_reposicao_destino: 0,
            grupo: filtros.value.produtoTabelaFiltro,
          }
        );
        listaProdutosEstoque.value = response.data.data;
        listaProdutosEstoque.value.forEach((produto) => {
          produto.quantidade = "";
        });
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const listagemDetalhada = async () => {
      produtosSelecionados.value = [];
      try {
        loading.value = true;
        const response = await store.dispatch(
          "transferencia/listagemDetalhada",
          {
            id: transferenciaId,
            per_page: 1000,
          }
        );
        response.data.result.data.forEach((elemento) => {
          if (elemento.produto_id != null) {
            produtosSelecionados.value.push(elemento);
          }
        });
        const statusUsarSaida = ["enviado", "cancelado", "criado", "rascunho"];
        produtosSelecionados.value.forEach((produto) => {
          const produtoDetalhe = produtosDetalhe.value.find(
            (p) => p.id === produto.produto_id
          );
          if (statusUsarSaida.includes(transferenciaDetalhes.value.status)) {
            produto.quantidade = produto.quantidade_saida;
          } else {
            produto.quantidade =
              produtoDetalhe?.lotes?.[0]?.quantidadeEntrada ??
              produto.quantidade_saida;
          }
        });
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const adicionarProduto = async (row) => {
      const produto = [
        {
          id: row.id,
          lote_destino: row.controla_lote == 1 ? "Não Localizado" : undefined,
          lote: row.lote ? row.lote.split(" - ")[0] : "",
          quantidade: row.quantidade ? parseFloat(row.quantidade) : 0,
        },
      ];
      try {
        await store.dispatch("transferencia/adicionarProduto", {
          action: "adicionar-produto",
          produtos: produto,
          id_transferencia: transferenciaId,
        });
        quasar.notify({
          message: "Produto selecionado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listagemDetalhada();
        listarProdutosEstoque();
      } catch (error) {
        let mensagem = "Erro ao selecionar Produto";
        if (error.response.data.result) {
          mensagem = error.response.data.result.error;
        }
        quasar.notify({
          message: mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const removerProduto = async (row) => {
      const produto = [
        {
          id: row.produto_id,
        },
      ];
      try {
        await store.dispatch("transferencia/removerProduto", {
          action: "remover-produto",
          produtos: produto,
          id_transferencia: transferenciaId,
        });
        quasar.notify({
          message: "Produto removido com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listagemDetalhada();
      } catch (error) {
        let mensagem = "Erro ao remover Produto";
        if (error.response.data.result) {
          mensagem = error.response.data.result.error;
        }
        quasar.notify({
          message: mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const alterarSolicitante = async () => {
      disable.value = true;
      try {
        await store.dispatch("transferencia/alterarSolicitante", {
          id_transferencia: transferenciaId,
          solicitante_id: dados.value.usuario.id,
        });
        quasar.notify({
          message: "Solicitante alterado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        detalharTransferencia();
        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro ao alterar solicitante",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disable.value = false;
      }
    };

    const alterarNecessidade = async () => {
      if (
        necessidade.value == "" ||
        necessidade.value == undefined ||
        necessidade.value <= 0
      ) {
        return;
      }
      disable.value = true;
      try {
        await store.dispatch("transferencia/alterarNecessidade", {
          id_transferencia: transferenciaId,
          necessidade_numero: necessidade.value,
        });
        quasar.notify({
          message: "Numero da necesidade alterado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disable.value = false;
        detalharTransferencia();
      } catch (error) {
        quasar.notify({
          message: "Erro ao alterar necessidade",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disable.value = false;
      }
    };

    const alterarSeparador = async () => {
      disable.value = true;
      try {
        await store.dispatch("transferencia/alterarSeparador", {
          id_transferencia: transferenciaId,
          responsavel_separacao_id: dados.value.separador.id,
        });
        quasar.notify({
          message: "Separador alterado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        detalharTransferencia();
        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro ao alterar separador",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disable.value = false;
      }
    };

    const alterarEstadoTransferencia = async (timeOut) => {
      if (tipoAuth.value == "biometria" && imagemBase64.value == null) {
        biometria.value = !biometria.value;
        quasar.notify({
          message: "Biometria não encontrada",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (tipoAuth.value == "assinatura" && imagemBase64.value == null) {
        salvarAssinatura.value++;
        const timer = setTimeout(() => {
          alterarEstadoTransferencia(1);
        }, 1000);
        if (timeOut == 1) {
          quasar.notify({
            message: "Assinatura não encontrada",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          clearTimeout(timer);
          return;
        }

        return;
      }

      if (tipoAuth.value == "web_pin" && pin.value == "") {
        quasar.notify({
          message: "Digite o Pin",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      let action;
      switch (transferenciaDetalhes.value.status) {
        case "rascunho":
          action = "de-rascunho-para-criado";
          break;
        case "criado":
          action = "enviar";
          break;
        case "enviado":
          action = "receber";
          break;
      }
      try {
        if (
          (tipoAuth.value == "biometria" && imagemBase64.value == null) ||
          (tipoAuth.value == "assinatura" && imagemBase64.value == null)
        ) {
          quasar.notify({
            message: "Erro a o tentar requisição imagem vazia",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }

        if (tipoAuth.value == "web_pin") {
          const response = await store.dispatch("requisicao/checarPin", {
            pin: pin.value,
            user_id: usuarioBiometria.value,
          });

          if (response.data.result.pin_correto) {
            quasar.notify({
              message:
                "Senha Validada com Sucesso, a requisição será finalizada!",
              color: "positive",
              actions: [
                {
                  label: "fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          } else {
            quasar.notify({
              message: "PIN digitado, não corresponde ao pin do usuário!",
              color: "negative",
              actions: [
                {
                  label: "fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            return;
          }
        }

        if (action != "receber") {
          await store.dispatch("transferencia/alterarEstadoTransferencia", {
            id_transferencia: transferenciaId,
            action: action,
            manipulador:
              transferenciaDetalhes.value.status == "rascunho"
                ? undefined
                : {
                    user_id: usuarioBiometria.value,
                    auth_type:
                      tipoAuth.value == "web_pin"
                        ? pin.value
                        : tipoAuth.value == "token"
                        ? "token"
                        : tipoAuth.value === null
                        ? undefined
                        : tipoAuth.value,
                    auth_content:
                      tipoAuth.value == "token"
                        ? store.state.autenticacao.token
                        : imagemBase64.value,
                  },
          });
          quasar.notify({
            message: "Ordem de transferência alterada com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          if (
            transferenciaDetalhes.value.status == "criado" ||
            transferenciaDetalhes.value.status == "enviado"
          ) {
            voltar();
          }
          detalharTransferencia();
          return;
        }
        let array = [];
        produtosSelecionados.value.forEach((produto, indice) => {
          array.push(produto);
          array[indice].id = array[indice].produto_id;
        });

        if (
          parseFloat(array[0].quantidade_saida) <
          parseFloat(array[0].quantidade)
        ) {
          quasar.notify({
            message: "A quantidade recebida não pode ser maior que a enviada",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }

        await store.dispatch("transferencia/alterarEstadoTransferencia", {
          id_transferencia: transferenciaId,
          action: action,
          produtos: produtosSelecionados.value,
          manipulador:
            transferenciaDetalhes.value.status == "rascunho"
              ? undefined
              : {
                  user_id: usuarioBiometria.value,
                  auth_type:
                    tipoAuth.value == "web_pin"
                      ? pin.value
                      : tipoAuth.value == "token"
                      ? "token"
                      : tipoAuth.value,
                  auth_content:
                    tipoAuth.value == "token"
                      ? store.state.autenticacao.token
                      : imagemBase64.value,
                },
        });
        valoresInvertidos();
      } catch (error) {
        quasar.notify({
          message: error.response.data.result.error,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const definirLabelBotaoAlterarTransferencia = () => {
      switch (transferenciaDetalhes.value.status) {
        case "rascunho":
          labelAlterarTransferencia.value = "Criar";
          break;
        case "criado":
          labelAlterarTransferencia.value = "Enviar";
          break;
        case "enviado":
          labelAlterarTransferencia.value = "Receber";
          break;
      }
    };

    const valoresInvertidos = async () => {
      try {
        const response = await store.dispatch(
          "transferencia/valoresInvertidos",
          {
            descricao: "transferência de retorno por entrada divergente",
            id: transferenciaId,
            somente_itens_divergentes: produtosSelecionados.value.length,
          }
        );
        let id = "";
        if (response.data.result.id) {
          id = response.data.result.id;
        }
        store.dispatch("transferencia/alterarEstadoTransferencia", {
          id_transferencia: id,
          action: "enviar",
        });
        quasar.notify({
          message: "Ordem de transferência alterada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        voltar();
        detalharTransferencia();
      } catch (error) {
        console.log(error);
      }
    };

    const listarGrupos = async (pesquisa) => {
      try {
        const response = await store.dispatch(
          "transferencia/listarGruposProduto",
          {
            per_page: 5,
            vendor_id: dados.value.origemId,
            search: pesquisa,
          }
        );
        optionsFiltroProdutos.value = [];
        if (response.data.results.data) {
          let array = response.data.results.data;
          array.forEach((grupo) => {
            optionsFiltroProdutos.value.push(grupo.name);
          });
        }
        listarProdutosEstoque();
      } catch (error) {
        console.log(error);
      }
    };

    const options = (id) => {
      let options = [];
      listaProdutosEstoque.value.forEach((e) => {
        if (e.id == id && e.controla_lote != 0) {
          e.localizacoes.forEach((localizacao) => {
            if (parseFloat(localizacao.amount) > 0) {
              options.push(`${localizacao.batch} - ${localizacao.amount}`);
            }
          });
        }
      });
      return options;
    };

    const receberUsuarioBiometria = (value) => {
      if (value?.idTabela && typeof value.idTabela === "number") {
        usuarioBiometria.value = value.idTabela;
      } else if (value?.idTabela && !isNaN(parseInt(value.idTabela))) {
        usuarioBiometria.value = parseInt(value.idTabela);
      } else if (value?.id && typeof value.id === "number") {
        usuarioBiometria.value = value.id;
      } else if (value?.id && !isNaN(parseInt(value.id))) {
        usuarioBiometria.value = parseInt(value.id);
      } else {
        usuarioBiometria.value = getUsuarioId();
      }
    };

    const recebeBiometria = async (value) => {
      imagemBase64.value = value;
    };

    const recebeAssinatura = async (value) => {
      imagemBase64.value = value;
    };

    const receberResultadoBiometria = (value) => {
      if (value) {
        alterarEstadoTransferencia();
      }
    };
    watch(
      () => filtros.value.usuario,
      () => {
        listarUsuarios();
      }
    );

    watch(
      () => filtros.value.separador,
      () => {
        listarSeparador();
      }
    );

    watch(
      () => filtros.value.produtoEstoque,
      () => {
        listarProdutosEstoque();
      }
    );

    watch(
      () => filtros.value.produtoTabelaFiltro,
      () => {
        listarProdutosEstoque();
      }
    );

    watch(
      () => dados.value.separador,
      () => {
        if (!alterarIndividuos.value) {
          return;
        }
        if (dados.value.separador != "") {
          userTipo.value = true;
          confirm.value = true;
        }
      }
    );

    watch(
      () => dados.value.usuario,
      () => {
        if (!alterarIndividuos.value) {
          return;
        }
        if (dados.value.usuario != "") {
          userTipo.value = false;
          confirm.value = true;
        }
      }
    );

    onMounted(detalharTransferencia);
    onMounted(listarUsuarios);

    const formatDateBrasil = (dateString) => {
      const date = new Date(dateString);

      const formatted = date.toLocaleDateString("pt-BR"); // dd/mm/yyyy
      return formatted;
    };

    return {
      columns,
      time,
      columns2,
      detalharTransferencia,
      transferenciaId,
      listarUsuarios,
      dados,
      transferenciaDetalhes,
      listaUsuarios,
      filtros,
      loadingInner,
      voltar,
      listarSeparador,
      pin,
      loadingInnerSeparador,
      listaUsuariosSeparador,
      listarProdutosEstoque,
      listaProdutosEstoque,
      listagemDetalhada,
      produtosSelecionados,
      adicionarProduto,
      removerProduto,
      userTipo,
      confirm,
      alterarSolicitante,
      alterarNecessidade,
      alterarSeparador,
      alterarEstadoTransferencia,
      tipoAuth,
      receberUsuarioBiometria,
      usuarioBiometria,
      mobile,
      loading,
      salvarAssinatura,
      recebeBiometria,
      recebeAssinatura,
      receberResultadoBiometria,
      biometria,
      labelAlterarTransferencia,
      definirLabelBotaoAlterarTransferencia,
      optionsFiltroProdutos,
      valoresInvertidos,
      usuarioLogado,
      listarGrupos,
      atualizarDados,
      alterarIndividuos,
      rightDrawerOpen,
      historico,
      necessidade,
      disable,
      filterSolicitante(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          listarUsuarios(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
      filterSeparator(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          listarSeparador(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
      options,
    };
  },
};
</script>

<style scoped>
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.texto-titulo-input {
  color: #21324a;
}
.descricao-produto {
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  max-width: 300px;
  overflow-wrap: break-word !important;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .cursor {
    font-size: 14px !important;
    margin-top: 18px !important;
  }
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
    color: #21324a;
  }

  .input {
    font-size: 12px;
  }
  .container-solicitante {
    margin: 50px 0px 0px 0px;
  }
  .radio-centro {
    font-size: 12px;
  }
  .input-filtro-tabela {
    margin-top: 10px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .input-codigo-epi-grid {
    width: 70px;
    outline: none;
  }
}
</style>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}

.my-sticky-dynamic thead th {
  position: sticky;
  top: 0;
  z-index: 1; /* Certifique-se que está acima do conteúdo */
  background-color: #d9effc; /* Para corresponder ao estilo do header */
}
</style>
